





























import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";
import jsQR from "jsqr";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CameraComponent",
  components: { QErrors },
})
export default class CameraComponent extends Vue {
  public isShow = false;
  public errors = {};
  public message = "";
  public scanning = false;
  private video: HTMLVideoElement | null = null;
  private stream: MediaStream | null = null;

  public initCamera() {
    if (!navigator.mediaDevices) {
      this.message = "このブラウザはカメラをサポートしていません。";
      return;
    }
    this.video = document.querySelector("#js-video");
    if (!this.video) {
      this.message = "カメラを起動できません。";
      return;
    }
    navigator.mediaDevices
      .getUserMedia({
        audio: false,
        video: {
          facingMode: "environment", // リアカメラ
        },
      })
      .then((stream) => {
        this.stream = stream;
        this.video.srcObject = stream;
        this.video.onloadedmetadata = () => {
          this.video?.play();
          this.findQR();
        };
      })
      .catch(() => {
        this.$emit("camera-error", "カメラを起動できません。");
      });

    return;
  }

  public checkQRUseLibrary() {
    if (!this.video || !this.scanning) { return; }

    try {
      const canvas = document.querySelector("#js-canvas") as HTMLCanvasElement;
      if (!canvas) { return; }
      const context = canvas.getContext("2d");
      if (!context) { return; }

      canvas.width = this.video.videoWidth;
      canvas.height = this.video.videoHeight;
      context.drawImage(this.video, 0, 0, canvas.width, canvas.height);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const code = jsQR(imageData.data, canvas.width, canvas.height);

      if (code) {
        this.handleQRCode(code.data);
      } else {
        console.log("リトライ");
        setTimeout(() => this.checkQRUseLibrary(), 200);
      }
    } catch (error) {
      console.error("QRスキャンエラー:", error);
      setTimeout(() => this.checkQRUseLibrary(), 500);
    }
  }

  // @todo: BarcodeDetector APIを使ってQRコードを検出するテストは未確認
  public checkQRUseBarcodeDetector() {
    if (!this.video || !this.scanning) { return; }

    try {
      const BarcodeDetectorAPI = (window as any).BarcodeDetector;
      const detector = new BarcodeDetectorAPI({ formats: ["qr_code"] });

      detector
        .detect(this.video)
        .then((barcodes: any[]) => {
          if (barcodes.length > 0) {
            this.handleQRCode(barcodes[0].rawValue);
          } else {
            setTimeout(() => this.checkQRUseBarcodeDetector(), 200);
          }
        })
        .catch(() => {
          this.checkQRUseLibrary();
        });
    } catch (error) {
      error;
      this.checkQRUseLibrary();
    }
  }

  public handleQRCode(data: string) {
    qNotify.success({
      text: "QRコードを読み取りました",
    });
    this.$emit("qr-detected", data);
    this.close();
  }

  public findQR() {
    this.scanning = true;
    const BarcodeDetectorAPI = (window as any).BarcodeDetector;
    if (BarcodeDetectorAPI) {
      BarcodeDetectorAPI.getSupportedFormats()
        .then((supportedFormats: string[]) => {
          if (supportedFormats.includes("qr_code")) {
            this.checkQRUseBarcodeDetector();
          } else {
            this.checkQRUseLibrary();
          }
        })
        .catch(() => {
          this.checkQRUseLibrary();
        });
    } else {
      this.checkQRUseLibrary();
    }
  }

  public show() {
    this.errors = {};
    this.message = "";
    this.isShow = true;

    this.$nextTick(() => {
      this.initCamera();
      if (this.message) {
        this.$emit("camera-error", this.message);
      }
    });
  }

  public close() {
    this.scanning = false;
    if (this.stream) {
      const tracks = this.stream.getTracks();
      for (const track of tracks) {
        track.stop();
      }
      this.stream = null;
    }
    if (this.video) {
      this.video.srcObject = null;
    }
    this.isShow = false;
  }
}
